import {
  SET_OS
} from '../actions'

const initialState = {
  osName: 'default',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OS:
      return {
        ...state,
        osName: action.osName,
      }
    default:
      return state
  }
}

export default reducer